import * as React from 'react';
import { Label } from 'reactstrap';
import './filter.css';

export interface ISearchBoxProps {
  onSearch: (text: string) => void,
  text?: string;
};

export interface ISearchBoxState {
  text: string,
};

export class SearchBox extends React.Component<ISearchBoxProps, ISearchBoxState> {
  constructor(props: ISearchBoxProps) {
    super(props);

    this.state = {
      text: this.props.text ? this.props.text : ''
    }
  }
  public componentWillReceiveProps(props: ISearchBoxProps) {
    if (props.text === "") {
      this.setState({ text: "" })
    }
  }

  public handleTextChange = (newText: string) => {
    this.props.onSearch(newText);
    this.setState({ text: newText });
  }

  public handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  public render() {
    return (
      <div className="filter-container">
        <Label>Filter</Label>
        <form>
          <div className="pt-input-group">
            <input
              className="filter-input"
              type="search"
              value={this.state.text}
              placeholder="&#xF002; Search"
              dir="auto"
              onChange={(event) => this.handleTextChange(event.target.value)}
              onKeyPress={this.handleKeyPress}
            />
          </div>
        </form>
      </div>
    )
  }
}

export default SearchBox;